import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import EditAvatarDialog from '@/app/[locale]/(worlds)/profile/components/EditAvatarDialog';
import IconCamera from '@/components/assets/icon_camera_2.svg';
import PopoverMenu from '@/components/PopoverMenu';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useConfigsContext } from '@/context/ConfigsContext';
import { showToast } from '@/lib/toast';
import { cn } from '@/lib/utils';
import { updateProfileMeByCmsAccountId } from '@/server/lib/profile';
type EditAvatarMenuProps = {
  defaultAvatarUrl: string;
};
function EditAvatarMenu({
  defaultAvatarUrl
}: EditAvatarMenuProps) {
  const t = useTranslations();
  const matched1440 = useMediaQuery('(min-width: 1440px)');
  const {
    store,
    setStore
  } = useConfigsContext();
  const htcToken = store?.credentials?.htcToken;
  const cmsAccountId = store?.profile?.id;
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const handleEdit = () => {
    setIsEditing(true);
  };
  const handleRemove = async () => {
    if (!htcToken || !cmsAccountId) {
      throw new Error('No HTC token or CMS account ID');
    }
    setIsSaving(true);
    try {
      const res = await updateProfileMeByCmsAccountId(cmsAccountId, {
        profile_image: ''
      });
      if (res?.status === 200 && res?.results) {
        setStore(value => ({
          ...value,
          profile: {
            ...value.profile!,
            image: '',
            avatarSnapshot: res.results.active_avatar.head_icon_url
          }
        }));
      } else {
        throw new Error('Failed to remove profile avatar');
      }
    } catch (error) {
      console.error('Failed to remove profile avatar: ', error);
    } finally {
      showToast({
        message: t('profile-page.photo-removed-successfully'),
        type: 'success'
      });
      setIsSaving(false);
      setMenuOpen(false);
    }
  };
  return <>
      <Popover open={menuOpen} onOpenChange={setMenuOpen}>
        <PopoverTrigger asChild>
          <div className="bg-vive-primary-70 hover:bg-vive-primary-80 absolute right-0 bottom-0 grid size-[34px] cursor-pointer place-items-center rounded-full transition-all" onClick={() => setMenuOpen(true)}>
            <IconCamera className="size-5" />
          </div>
        </PopoverTrigger>
        <PopoverContent side="bottom" align={matched1440 ? 'start' : 'center'} className={cn('mt-2 border-none bg-transparent p-0', {
        'cursor-wait': isSaving
      })}>
          <PopoverMenu className="bg-vive-primary-70 rounded-[3px]">
            <PopoverMenu.Group>
              <PopoverMenu.Item onClick={handleEdit} isLoading={isSaving}>
                <div className="body-1 text-inherit">{t('profile-page.upload-photo')}</div>
              </PopoverMenu.Item>
              <PopoverMenu.Item onClick={handleRemove} isLoading={isSaving}>
                <div className="body-1 text-inherit">{t('profile-page.remove-photo')}</div>
              </PopoverMenu.Item>
            </PopoverMenu.Group>
          </PopoverMenu>
        </PopoverContent>
      </Popover>
      <EditAvatarDialog defaultAvatarUrl={defaultAvatarUrl} isEditing={isEditing} setIsEditing={setIsEditing} />
    </>;
}
export default EditAvatarMenu;